import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '@services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {
  }

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkAuth(state);
  }

  async checkAuth(state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    if (!this.auth.loggedIn()) {
      return this.router.createUrlTree(['/login']);
    }
    const mustChange = this.auth.authCredentials()?.mustChangePassword ?? false;
    const onForcePage = state.url.startsWith('/force-password-change');
    if (mustChange && !onForcePage) {
      return this.router.createUrlTree(['/force-password-change']);
    }
    if (!mustChange && onForcePage) {
      return this.router.createUrlTree(['/landing']);
    }
    return true;
  }
}
